module.exports = __webpack_public_path__ + "static/media/hpm-image-v1.d7689ece.jpeg";